<script>
	export let params = {};
	
	import PainelBox from '../templates/PainelBox.svelte';
	import Listagem from '../Listagem.svelte';
	import { TiposObjetosListagem } from '../../utils';
</script>

<PainelBox 
	largura="12" 
	deslocamento="0"
	titulo="Listagem de Avaliações">
	
	<Listagem 
		chaveLSCache="AVAL_LISTAGEM_AVALIACOES_CACHE_PG" 
		endpointRecurso="avaliacoes/status/{params.status}" 
		tipoObjeto={TiposObjetosListagem.AVALIACAO} 
		on:routeEvent />
</PainelBox>